import { Component, OnInit } from '@angular/core';
import { empty } from 'rxjs';
import { LoginService } from '../app/services/login.service';
import {Router} from '@angular/router';
import { VersionCheckService } from './core/services/version-check.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'eagle-eye';
  checkAccess: any;
  
  constructor(
    private LogStart: LoginService, 
    private router: Router,
    private versionCheckService: VersionCheckService,
    private http: HttpClient
  ) {
    // console.log('window.location.href',window.location.href)
  }
  ngOnInit() {
    // Load version from assets/version.json and initialize version checking
    this.http.get<{version: string}>('assets/version.json').subscribe(
      (versionData) => {
        this.versionCheckService.initVersionCheck(versionData.version);
      },
      (error) => {
        console.warn('Failed to load version.json:', error);
        // Initialize with default version if fetch fails
        this.versionCheckService.initVersionCheck('unknown');
      }
    );
    
    this.checkAccess = this.LogStart.loginStart();
    if ( this.checkAccess == 'no login') {
      // this.router.navigate(['/login']);
      if (window.location.href.includes("video")) {
        // this.router.navigate(['/video/123']);
        window.location.href
      }
      if (window.location.href.includes("consumervoice")) {
        window.location.href
      }
      else if (window.location.href.includes("/home/survey/")) {
        // this.router.navigate(['/video/123']);
        window.location.href
        
      }
      else if (window.location.href.includes("file-upload")) {
        // this.router.navigate(['/video/123']);
        window.location.href
        
      }else{
        if(window.location.href.includes('?email') && window.location.href.includes('type'))
        {
          // console.log('Simple AutoFill Email Login with type');
          let url = window.location.href.split('?email=');
          let email = url[1].split('&type=');
          let type = email[1];
          this.router.navigate(['/login'],{state: { redirect: window.location.pathname } ,queryParams:{'email':email[0],'type':type}});
        }
        else if(window.location.href.includes('?email=')) {
          // console.log('Simple AutoFill Email Login');
          let url = null;
          url = window.location.href.split('?email=');
          this.router.navigate(['/login'],{state: { redirect: window.location.pathname } ,queryParams:{'email':url ? url[1] : null}});
        }
        else if(window.location.pathname === '/')
        {
          // this.router.navigate(['/login'],{state: { redirect: window.location.pathname }});
          this.router.navigate(['/login']);
          // console.log('Simple Login else if 3',window.location.pathname);
        }
        else
        {
          this.router.navigate(['/login'],{state: { redirect: window.location.pathname }});
          // console.log('else last ',window.location.pathname);
        }
      }
    }
    else {
      // this.router.navigate(['/home/dashboard']);
    }
  }
}
